module.exports = __webpack_public_path__ + "images/branding/manpower/left_tab.gif";